import { useEffect } from "react";

/**
 * Mirrors the legacy login.js behaviour: clears stale session/cache data from
 * localStorage and checks whether the SignalR desktop-link application is
 * running locally. Runs once on mount.
 */
export const useLoginPageSetup = () => {
  useEffect(() => {
    const removeContaining = (substring: string) =>
      Object.keys(localStorage)
        .filter((k) => k.includes(substring))
        .forEach((k) => localStorage.removeItem(k));

    // Remove specific keys
    [
      "permanentNotify",
      "telephony-current-incoming-call",
      "AccountStructure",
      "NOTIFY_ERROR_COUNT",
      "PROJECTS_LOG_SORT_DIRECTION",
      "SIMPLE_TABS",
      "PROJECTS_COMPANIES_FILTER",
      "RedirectSection",
      "SELECTED_TAGS_TASKS",
      "SELECTED_TAGS_OPPORTUNITIES",
    ].forEach((k) => localStorage.removeItem(k));

    // Remove all keys containing these substrings
    removeContaining("NotificationCache");
    removeContaining("TaskList");
    removeContaining("ToggleState_");
    removeContaining("user_roles_cache");

    // Mark datatable states for reset on next load
    localStorage.setItem("resetProjectOpportunities", "true");
    localStorage.setItem("resetProjectDocuments", "true");

    // noteQuickCompose.closeAll() — removes the three localStorage keys that
    // track open note/quick-compose panel state in the legacy UI.
    localStorage.removeItem("quickTasksWrapper");
    localStorage.removeItem("noteComposerWrapper");
    localStorage.removeItem("noteEditorWrapper");

    // Check whether the SignalR desktop-link application is running locally
    fetch("https://localhost:64753/signalr/hubs", { cache: "no-store", signal: AbortSignal.timeout(2000) })
      .then(() => (document.cookie = "desktopLinkIsConnected=true; path=/"))
      .catch(() => (document.cookie = "desktopLinkIsConnected=false; path=/"));
  }, []);
};
